"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntensityDenominator = exports.TargetStatus = exports.TargetFramework = exports.CalculationNoticeType = exports.CalculationStatus = exports.Scope2Method = exports.AssetType = exports.DataQuality = exports.ActivityUnit = exports.FuelType = exports.ProcessType = exports.FugitiveGasType = exports.RefrigerantGasType = exports.VehicleType = exports.Scope2ActivityType = exports.Scope1ActivityType = exports.EmissionScope = void 0;
/**
 * GHG Protocol emission scopes
 */
var EmissionScope;
(function (EmissionScope) {
    EmissionScope["Scope1"] = "scope1";
    EmissionScope["Scope2"] = "scope2";
    EmissionScope["Scope3"] = "scope3";
})(EmissionScope || (exports.EmissionScope = EmissionScope = {}));
/**
 * Scope 1 activity categories
 */
var Scope1ActivityType;
(function (Scope1ActivityType) {
    Scope1ActivityType["StationaryCombustion"] = "stationary_combustion";
    Scope1ActivityType["MobileCombustion"] = "mobile_combustion";
    Scope1ActivityType["ProcessEmissions"] = "process_emissions";
    Scope1ActivityType["FugitiveEmissions"] = "fugitive_emissions";
})(Scope1ActivityType || (exports.Scope1ActivityType = Scope1ActivityType = {}));
/**
 * Scope 2 activity categories
 */
var Scope2ActivityType;
(function (Scope2ActivityType) {
    Scope2ActivityType["PurchasedElectricity"] = "purchased_electricity";
    Scope2ActivityType["PurchasedSteam"] = "purchased_steam";
    Scope2ActivityType["PurchasedHeating"] = "purchased_heating";
    Scope2ActivityType["PurchasedCooling"] = "purchased_cooling";
})(Scope2ActivityType || (exports.Scope2ActivityType = Scope2ActivityType = {}));
/**
 * Vehicle types for mobile combustion activities
 */
var VehicleType;
(function (VehicleType) {
    VehicleType["Car"] = "car";
    VehicleType["SmallCar"] = "small_car";
    VehicleType["MediumCar"] = "medium_car";
    VehicleType["LargeCar"] = "large_car";
    VehicleType["Van"] = "van";
    VehicleType["HGV"] = "hgv";
    VehicleType["Motorcycle"] = "motorcycle";
})(VehicleType || (exports.VehicleType = VehicleType = {}));
/**
 * Refrigerant gas types (HFCs, HCFCs, natural refrigerants)
 */
var RefrigerantGasType;
(function (RefrigerantGasType) {
    RefrigerantGasType["R134A"] = "R134A";
    RefrigerantGasType["R410A"] = "R410A";
    RefrigerantGasType["R404A"] = "R404A";
    RefrigerantGasType["R407C"] = "R407C";
    RefrigerantGasType["R507A"] = "R507A";
    RefrigerantGasType["R422D"] = "R422D";
    RefrigerantGasType["R32"] = "R32";
    RefrigerantGasType["R1234yf"] = "R1234yf";
    // R1234ze = 'R1234ze', // Only scope 3
    RefrigerantGasType["R290"] = "R290";
    RefrigerantGasType["R600A"] = "R600A";
    RefrigerantGasType["R744"] = "R744";
    RefrigerantGasType["R717"] = "R717";
    RefrigerantGasType["R22"] = "R22";
    RefrigerantGasType["R12"] = "R12";
})(RefrigerantGasType || (exports.RefrigerantGasType = RefrigerantGasType = {}));
/**
 * High-GWP industrial fugitive gas types
 */
var FugitiveGasType;
(function (FugitiveGasType) {
    FugitiveGasType["SF6"] = "SF6";
    FugitiveGasType["NF3"] = "NF3";
    FugitiveGasType["CF4"] = "CF4";
    FugitiveGasType["C2F6"] = "C2F6";
    // C3F8 = 'C3F8', // Can't find in Climatiq
    FugitiveGasType["CHF3"] = "CHF3";
})(FugitiveGasType || (exports.FugitiveGasType = FugitiveGasType = {}));
/**
 * Process types for industrial process emissions
 */
var ProcessType;
(function (ProcessType) {
    ProcessType["CementProduction"] = "cement_production";
    ProcessType["SteelProduction"] = "steel_production";
    // ChemicalSynthesis = 'chemical_synthesis', // This is too broad. @TODO - allow user to type in a specific chemical compound that is being synthesized.
    // AluminumSmelting = 'aluminum_smelting',
    ProcessType["GlassManufacturing"] = "glass_manufacturing";
    ProcessType["LimeProduction"] = "lime_production";
    // Other = 'other',
})(ProcessType || (exports.ProcessType = ProcessType = {}));
/**
 * Fuel types for combustion activities
 */
var FuelType;
(function (FuelType) {
    // Gaseous fuels
    FuelType["NaturalGas"] = "natural_gas";
    FuelType["LPG"] = "lpg";
    FuelType["Propane"] = "propane";
    FuelType["Butane"] = "butane";
    FuelType["CNG"] = "cng";
    FuelType["LNG"] = "lng";
    FuelType["Hydrogen"] = "hydrogen";
    // Liquid fuels
    FuelType["Diesel"] = "diesel";
    FuelType["Petrol"] = "petrol";
    FuelType["Biodiesel"] = "biodiesel";
    FuelType["HeavyFuelOil"] = "heavy_fuel_oil";
    FuelType["LightFuelOil"] = "light_fuel_oil";
    FuelType["Kerosene"] = "kerosene";
    FuelType["JetFuel"] = "jet_fuel";
    FuelType["Ethanol"] = "ethanol";
    FuelType["HVO"] = "hvo";
    // Solid fuels — coal
    FuelType["Coal"] = "coal";
    FuelType["CoalIndustrial"] = "coal_industrial";
    FuelType["CoalDomestic"] = "coal_domestic";
    FuelType["Anthracite"] = "anthracite";
    FuelType["Coke"] = "coke";
    // Solid fuels — wood
    FuelType["Wood"] = "wood";
    FuelType["WoodLogs"] = "wood_logs";
    FuelType["WoodChips"] = "wood_chips";
    FuelType["WoodPellets"] = "wood_pellets";
    FuelType["Biomass"] = "biomass";
    // Electric/Alternative (mobile combustion only)
    FuelType["Electric"] = "electric";
    FuelType["PlugInHybrid"] = "plugin_hybrid";
    FuelType["Hybrid"] = "hybrid";
    FuelType["Unknown"] = "unknown";
})(FuelType || (exports.FuelType = FuelType = {}));
/**
 * Activity data units
 */
var ActivityUnit;
(function (ActivityUnit) {
    // Volume
    ActivityUnit["Litres"] = "l";
    ActivityUnit["Gallons"] = "gallon_us";
    ActivityUnit["CubicMeters"] = "m3";
    ActivityUnit["CubicFeet"] = "cubic_foot";
    // Weight
    ActivityUnit["Kilograms"] = "kg";
    ActivityUnit["Tonnes"] = "t";
    ActivityUnit["Pounds"] = "lb";
    ActivityUnit["ShortTons"] = "ton";
    // Energy
    ActivityUnit["KWh"] = "kWh";
    ActivityUnit["MWh"] = "MWh";
    ActivityUnit["GJ"] = "GJ";
    ActivityUnit["MJ"] = "MJ";
    ActivityUnit["Therms"] = "therm";
    ActivityUnit["MMBTU"] = "MMBTU";
    // Distance
    ActivityUnit["Kilometers"] = "km";
    ActivityUnit["Miles"] = "mi";
    // Area
    ActivityUnit["SquareMeters"] = "m2";
    ActivityUnit["SquareFeet"] = "ft2";
    // Count
    ActivityUnit["Each"] = "each";
})(ActivityUnit || (exports.ActivityUnit = ActivityUnit = {}));
/**
 * Data quality ratings — auto-derived from how the calculation was performed.
 * Set on EmissionCalculation, not user-selected.
 */
var DataQuality;
(function (DataQuality) {
    DataQuality["Measured"] = "measured";
    DataQuality["Calculated"] = "calculated";
    DataQuality["CalculatedFallback"] = "calculated_fallback";
    DataQuality["Estimated"] = "estimated";
    DataQuality["Failed"] = "failed";
})(DataQuality || (exports.DataQuality = DataQuality = {}));
/**
 * Asset types for operational unit tracking
 */
var AssetType;
(function (AssetType) {
    AssetType["Facility"] = "facility";
    AssetType["Vehicle"] = "vehicle";
    AssetType["ManufacturingFacility"] = "manufacturing_facility";
    AssetType["DataCentre"] = "data_centre";
    AssetType["Equipment"] = "equipment";
    AssetType["Other"] = "other";
})(AssetType || (exports.AssetType = AssetType = {}));
// ---------------------------------------------------------------------------
// Calculation & reporting enums (shared between backend and frontend)
// ---------------------------------------------------------------------------
/**
 * Scope 2 calculation methods per GHG Protocol Scope 2 Guidance
 */
var Scope2Method;
(function (Scope2Method) {
    Scope2Method["LocationBased"] = "location_based";
    Scope2Method["MarketBased"] = "market_based";
})(Scope2Method || (exports.Scope2Method = Scope2Method = {}));
/**
 * Calculation status
 */
var CalculationStatus;
(function (CalculationStatus) {
    CalculationStatus["Pending"] = "pending";
    CalculationStatus["Calculated"] = "calculated";
    CalculationStatus["Failed"] = "failed";
    /** @deprecated Use Failed instead */
    CalculationStatus["Error"] = "error";
    CalculationStatus["RequiresReview"] = "requires_review";
})(CalculationStatus || (exports.CalculationStatus = CalculationStatus = {}));
/**
 * Notice types for calculations
 */
var CalculationNoticeType;
(function (CalculationNoticeType) {
    CalculationNoticeType["Info"] = "info";
    CalculationNoticeType["Warning"] = "warning";
    CalculationNoticeType["Error"] = "error";
})(CalculationNoticeType || (exports.CalculationNoticeType = CalculationNoticeType = {}));
/**
 * Target framework types for emission reduction targets
 */
var TargetFramework;
(function (TargetFramework) {
    TargetFramework["SBTi"] = "sbti";
    TargetFramework["NetZero"] = "net_zero";
    TargetFramework["CarbonNeutral"] = "carbon_neutral";
    TargetFramework["Custom"] = "custom";
})(TargetFramework || (exports.TargetFramework = TargetFramework = {}));
/**
 * Target status
 */
var TargetStatus;
(function (TargetStatus) {
    TargetStatus["Active"] = "active";
    TargetStatus["Achieved"] = "achieved";
    TargetStatus["Missed"] = "missed";
    TargetStatus["Draft"] = "draft";
})(TargetStatus || (exports.TargetStatus = TargetStatus = {}));
/**
 * Standard intensity denominator fields available on asset types.
 * Values match the field keys in ASSET_TEMPLATE_CONFIGS.assetFields[].
 * Adding a new value here will cause a compile error in INTENSITY_FIELD_META
 * until branding metadata is provided for it.
 */
var IntensityDenominator;
(function (IntensityDenominator) {
    IntensityDenominator["FloorArea"] = "floorAreaM2";
    IntensityDenominator["Employees"] = "employeeCount";
    IntensityDenominator["OperatingHours"] = "operatingHoursPerYear";
    IntensityDenominator["RatedCapacity"] = "ratedCapacityKw";
    IntensityDenominator["ITLoad"] = "itLoadKw";
    IntensityDenominator["Racks"] = "rackCount";
    IntensityDenominator["PUE"] = "pue";
})(IntensityDenominator || (exports.IntensityDenominator = IntensityDenominator = {}));
